import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const CUDService = {}


CUDService.delete = function (token,url,data) {
    return fetch({
        url: url,
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

CUDService.store = function (token,url,data) {
    return fetch({
        url: url,
        method: 'post',
        data: data.param.values,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

CUDService.upload = function (token,url,data) {
    console.log(data)
    return fetch({
        url: url,
        method: 'post',
        data: data,
        headers:{
            "x-api-key":X_API_KEY,
            "Content-Type": "multipart/form-data",
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}


export default CUDService;
